import { useEffect, useState } from "react";

interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export function AboutChangelog() {
  const [entries, setEntries] = useState<ChangelogEntry[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch("/about/changelog.json", { headers: { Accept: "application/json" } })
      .then((r) => {
        if (!r.ok) throw new Error("not-found");
        return r.json();
      })
      .then((data) => {
        if (cancelled) return;
        if (Array.isArray(data)) setEntries(data as ChangelogEntry[]);
        else setError(true);
      })
      .catch(() => !cancelled && setError(true));
    return () => {
      cancelled = true;
    };
  }, []);

  if (!entries && !error) {
    return <div className="card" style={{ padding: 28, color: "var(--md-on-surface-var)" }}>Loading changelog…</div>;
  }

  if (error || !entries || entries.length === 0) {
    return (
      <div className="card" style={{ padding: 36, textAlign: "center" }}>
        <div className="lex-eyebrow">CHANGELOG</div>
        <h2 style={{ font: "var(--t-headline-sm)", fontStyle: "italic", marginTop: 6 }}>Nothing released yet.</h2>
        <p style={{ color: "var(--md-on-surface-var)", maxWidth: 480, margin: "8px auto 0" }}>
          When releases ship, they'll be listed here. Drop a <code>changelog.json</code> in the public/about folder to populate this page.
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: "grid", gap: 14 }}>
      {entries.map((e) => (
        <article key={e.version} className="card" style={{ padding: 20 }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
            <h3 style={{ font: "var(--t-headline-sm)", fontStyle: "italic", margin: 0, color: "var(--md-primary)" }}>{e.version}</h3>
            <span style={{ font: "var(--t-label-md)", color: "var(--md-on-surface-var)" }}>{e.date}</span>
          </div>
          <ul style={{ marginTop: 10, paddingLeft: 18, font: "var(--t-body-md)" }}>
            {e.changes.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </article>
      ))}
    </div>
  );
}

export default AboutChangelog;
